module.exports = __webpack_public_path__ + "static/media/user-check.a0d65596.svg";